import axios from "axios";
import jwt_decode from "jwt-decode";
import { trim, trimEnd, has } from "lodash";
import { createContext, useLayoutEffect, useMemo } from "react";
import STRING_CONSTANTS from "../shared/constants/StringConstants";
import { useSearchParams } from 'react-router-dom';
import RoutesPath from "../routes/routesPath";

const AuthContext = createContext({
  user: null,
  token: null,
});
export  const getPwaToken = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.has(STRING_CONSTANTS.TOKEN_PARAM_KEY)) {
    document.cookie = `${STRING_CONSTANTS.COOKIE_NAME}=${params.get(
      STRING_CONSTANTS.TOKEN_PARAM_KEY
    )};path=/;max-age=${60 * 60 * 24 * 365 * 100}`;
    return params.get(STRING_CONSTANTS.TOKEN_PARAM_KEY);
  }
  const token = document.cookie.split(";").reduce((acc, val) => {
    const [key, value] = val.split("=");
    if (trim(key) === STRING_CONSTANTS.COOKIE_NAME) acc = value;
    return acc;
  }, null);
  return  token;
};

// adapt token extraction logic for referral with other modules
const handleReferralTokenExtraction = (token) => {
  const location = window.location
  const currentPath = trimEnd(location.pathname, '/');
  if (currentPath !== RoutesPath.REFER_FRIEND) {
    return null
  }
  const decoded = jwt_decode(token);
  const PWA_USER_DATA_KEY = 'data';
  const decodedHasData = has(decoded, PWA_USER_DATA_KEY)
  if (!decodedHasData) {
    return decoded
  }
  return JSON.parse(decoded[PWA_USER_DATA_KEY] || '{}')
}

const getUserFromToken = (token) => {
  if (token === null) {
    return
  }
  const extractedData = handleReferralTokenExtraction(token)
  if (extractedData) {
    return extractedData
  }
  return JSON.parse(jwt_decode(token).data || '{}');
};

export const AuthProvider = ({ children }) => {
  const [params] = useSearchParams()
  const token = useMemo(getPwaToken, [params]);
  const user = useMemo(() => getUserFromToken(token), [token]);
  useLayoutEffect(() => {
    if (token !== null) {
      axios.interceptors.request.use((config) => {
        const url = new URL(config.url ? config.url.toString() : "");
        if (url.searchParams.has('token')) {
          return config
        }
        config.params = {
          token,
          ...config.params,
        };
        return config;
      });
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
